<template>
    <div>
        <rkm-list
            :items="data.form.historicoPedidosExames"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-col v-if="Number.isInteger(item.id)">
                            <rkm-icon
                                :id="`pronto-atendimento-exames-info-${item.id}`"
                                icon="info-circle"
                            />

                            <rkm-popover
                                :target="`pronto-atendimento-exames-info-${item.id}`"
                                triggers="hover"
                            >
                                <div>{{item.centroCusto.setor.nome}}</div>
                                <div>
                                    <rkm-icon icon="user" />
                                    {{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.codigo}}
                                </div>
                                <div>{{item.centroCusto.infraestrutura.nome}}</div>
                            </rkm-popover>
                        </rkm-col>
                    </rkm-col>

                    <rkm-col cols="3">
                        {{item.dataSolicitacao}}
                    </rkm-col>

                    <rkm-col cols="auto">
                        <div v-if="isEncaminhamento()">
                            {{item.medicoSolicitanteEncaminhamento}}
                        </div>

                        <div v-else>
                            {{`${item.lotacao.profissional.nome} - ${item.lotacao.ocupacao.nome} (${item.lotacao.ocupacao.codigo}) `}}
                        </div>

                        <div>
                            <template v-if="item.urgente">
                                <i
                                    v-rkm-tooltip.hover
                                    title="Urgente"
                                >
                                    <rkm-icon
                                        color="red"
                                        icon="exclamation-circle"
                                        small
                                    />
                                </i>
                            </template>
                            <strong> Justificativa: </strong>{{ item.justificativa }}
                        </div>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-list-group class="rkm-list-group">
                    <rkm-area
                        class="p-2"
                        title="Exames"
                    >
                        <rkm-list-group-item
                            v-for="(exame) in item.exames"
                            v-bind:key="uniqueId(exame.exame.id)"
                        >
                            <rkm-row class="align-items-center">
                                <rkm-col cols="2">
                                    <strong>Exame:</strong><br>{{exame.exame.nome}}
                                </rkm-col>

                                <rkm-col>
                                    <strong>Procedimento:</strong><br>{{exame.exame.procedimento.codigo}} - {{exame.exame.procedimento.nome}}
                                </rkm-col>

                                <rkm-col>
                                    <strong>Status:</strong><br>{{exame.status.nome}}
                                </rkm-col>

                                <rkm-col>
                                    <strong>Horário:</strong><br>{{exame.horarioRealizacao ? exame.horarioRealizacao : '-'}}
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>
                    </rkm-area>

                    <rkm-area title="Laudos" class="p-2">
                         <rkm-list-group-item
                            v-if="item.files.length === 0"
                            class="text-center"
                        >
                            <rkm-row>
                                <rkm-col>
                                    Não há registros correspondentes à sua solicitação
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>

                        <rkm-list-group-item
                            v-else
                            v-for="(file, indexLaudo) in item.files"
                            v-bind:key="uniqueId(indexLaudo)"
                        >
                            <rkm-row>
                                <rkm-col cols="auto"></rkm-col>

                                 <rkm-col cols="9">
                                    <div class="mt-1">
                                        <strong>Arquivo</strong>: {{file.name}}
                                    </div>
                                </rkm-col>

                                <rkm-col cols="2" class="text-right">
                                    <rkm-button
                                        @click.stop="Number.isInteger(file.id) ? downloadLaudo(file) : checkLaudo(file)"
                                        color="primary"
                                        small
                                        title="Visualizar"
                                    >
                                        <rkm-icon icon="download" />
                                    </rkm-button>
                                </rkm-col>
                            </rkm-row>
                        </rkm-list-group-item>
                    </rkm-area>
                </rkm-list-group>
            </template>
        </rkm-list>
    </div>
</template>

<script>
//Mixins
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {
        this.repositories.laudos = this.getConectaSusRepository('prontoAtendimento.laudoExame')
    },
    data: () => ({
        repositories: {
            laudo: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        isEncaminhamento() {
            return this.data.form.recepcao.isEncaminhamento
        },
        downloadLaudo(laudo) {
            this.repositories.laudos.download(laudo.id, { hash: laudo.hash }).then(response => {
                const file = new Blob([response.data], { type: "application/pdf" }),
                    url = window.URL.createObjectURL(file)

                window.open(url)
            })
        },
        checkLaudo(laudo) {
            window.open(URL.createObjectURL(laudo), '_blank')
        },
    },
    mixins: [repository, error],
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.horario {width: 125px;}
.profissional {width: 228px;}
.status {width: 240px;}
</style>